import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_ACCIDENTS } from './vehicleEntityConfigs';

const VehicleAccidents = () => <VehicleEntityGridPage config={VEHICLE_ACCIDENTS} />;

export default VehicleAccidents;
